/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:25
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-06-22 15:06:15
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\local\state.js
 */
const state = {
	centerCode: 'DHC-CENTERCODE', // 中心CODE
	networkFlag: 'DHC-NETWORKFLAG', // networkFlag
	researchCode: 'DHC-RESEARCHCODE', // 研究code
	routeMoreRecord: 'DHC-ROUTEMORERECORD', // 更多模块的路由记录
	userAuthority: 'DHC-USERAUTHORITY', // 用户功能权限,
	userInfo: 'DHC-USERINFO', // 用户信息
	userToken: 'DHC-USERTOKEN', // token
	identityType: 'DHC-IDENTITYTYPE', // 登录用户身份信息
	userOpenId: 'DHC-USEROPENID', // 登录用户openId
	testeeScrollTop: 'DHC-TESTEESCROLLTOP', // 滚动条位置
	researchScrollTop: 'DHC-RESEARCHSCROLLTOP', // 研究列表滚动条位置
	testeePaginationConfig: 'DHC-TESTEEPAGINATIONCONFIG', // 受试者列表分页参数
	recruitPaginationConfig: 'DHC-RECRUITPAGINATIONCONFIG' // 招募列表分页参数
}
export default state
